import React from 'react';
import { useUserCity } from '../hooks/useUserCity';
export function Hero() {
  const {
    city,
    isLoading
  } = useUserCity('Local');
  return <div className="mb-8" data-id="element-74">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6 font-sans" data-id="element-75">
        <span className="bg-[#FEF3C7] px-1 inline-flex items-center gap-2" data-id="element-76">
          {isLoading ? <span className="inline-block w-40 h-8 md:h-10 lg:h-12 rounded bg-gradient-to-r from-yellow-200 via-yellow-100 to-yellow-200 bg-[length:200%_100%] animate-shimmer align-middle" data-id="element-77" /> : <>{city} Doctors Reveal</>}
        </span>{' '}
        {!isLoading && <>
            When "Functional Drinking" Becomes a Real Problem{' '}
            <span className="text-gray-600 font-normal italic text-2xl md:text-3xl lg:text-4xl" data-id="element-78">
              (And What to Do Before It Gets Worse)
            </span>
          </>}
        {isLoading && <span className="ml-2 inline-block w-full max-w-2xl h-8 md:h-10 rounded bg-gradient-to-r from-gray-100 via-gray-50 to-gray-100 bg-[length:200%_100%] animate-shimmer" data-id="element-79" />}
      </h1>
    </div>;
}